// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__rfkNE","container":"LayoutSideNavigation_container__3Voze","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__ZwVMD"};